export default __webpack_public_path__ + "static/media/mariog3.27bad053.jpg";